import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import {Item} from 'VideoAudioQC/QCMedia/Redux/QCMediaActions';
import QCTabPanel from './QCTabPanel';
import QCReport from './QCReport/QCReportConnected';
import AdBreaks from './AdBreaks/AdBreaksConnected';
import Markup from './Markup/MarkupConnected';
import {TabIndex} from './QCTabsTypes';
import {OnEditMarkerProps} from '../VideoAudioQCContainer';
import Snapshots from './Snapshots/SnapshotConnected';

import './QCTabs.scss';

interface QCTabsProps {
    item: Item;
    activeTab: number;
    onEditMarkerIn: (props: OnEditMarkerProps) => void;
    onEditMarkerOut: (props: OnEditMarkerProps) => void;
    onGoToMarker: (start: number) => Promise<void>;
    activeTabChange: () => void;
    onCreateQCNote: (rowId: string) => void;
    onCreateAdBreak: (rowId: string) => void;
    onCreateMarkup: (rowId: string) => void;
    jobDeliveryDate: string;
}

export default function QCTabs(props: QCTabsProps) {
    const {
        item,
        activeTab,
        onEditMarkerIn,
        onEditMarkerOut,
        onGoToMarker,
        activeTabChange,
        onCreateQCNote,
        onCreateAdBreak,
        onCreateMarkup,
        jobDeliveryDate,
    } = props;

    return (
        <div className="qc-tabs-root">
            <AppBar position="static">
                <Tabs value={activeTab} onChange={activeTabChange} aria-label="QC Tabs">
                    <Tab label="QC report" id="tab-0" aria-controls="tabpanel-0" />
                    <Tab label="Ad breaks" id="tab-1" aria-controls="tabpanel-1" />
                    <Tab label="Markup" id="tab-2" aria-controls="tabpanel-2" />
                    <Tab label="Snapshots" id="tab-3" aria-controls="tabpanel-3" />
                </Tabs>
            </AppBar>
            <QCTabPanel value={activeTab} index={TabIndex.QCReport}>
                <QCReport
                    item={item}
                    jobDeliveryDate={jobDeliveryDate}
                    onCreateMarker={onCreateQCNote}
                    onGoToMarker={onGoToMarker}
                    onEditMarkerIn={onEditMarkerIn}
                    onEditMarkerOut={onEditMarkerOut}
                />
            </QCTabPanel>
            <QCTabPanel value={activeTab} index={TabIndex.AdBreaks}>
                <AdBreaks
                    item={item}
                    jobDeliveryDate={jobDeliveryDate}
                    onCreateMarker={onCreateAdBreak}
                    onEditMarker={onEditMarkerIn}
                    onGoToMarker={onGoToMarker}
                />
            </QCTabPanel>
            <QCTabPanel value={activeTab} index={TabIndex.Markup}>
                <Markup
                    jobDeliveryDate={jobDeliveryDate}
                    item={item}
                    onCreateMarker={onCreateMarkup}
                />
            </QCTabPanel>
            <QCTabPanel value={activeTab} index={TabIndex.Snapshot}>
                <Snapshots id={item.id} />
            </QCTabPanel>
        </div>
    );
}
